export const shadows = {
  outline: "0px 0px 0px 0.18rem var(--chakra-ui-focus-ring-color)",
};
